import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

interface LanguageSwitcherProps {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showLabel?: boolean;
}

const LanguageSwitcher = ({ variant = 'default', size = 'sm', showLabel = true }: LanguageSwitcherProps) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleLanguage}
      className="gap-2"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4" />
      {showLabel && (
        <span className="font-medium">
          {language === 'en' ? 'ไทย' : 'EN'}
        </span>
      )}
    </Button>
  );
};

export default LanguageSwitcher;
